import { Fragment } from "react";
import { Link } from "react-router-dom";

export const Learning = () => (
  <Fragment>
    <li>
      <a href="https://ai.siw.sg/" target="_blank" rel="noopener noreferrer">
        Azure AI Engineer
      </a>
    </li>
    <li>
      <Link to="/CDE-Intro">Cloudera Data Engineering</Link>
    </li>
    <li>
      <Link to="/hive">Cloudera Data Analyst</Link>
    </li>
    <li>
      <Link to="/CAI-Intro">Cloudera AI</Link>
    </li>
    <li>
      <Link to="#">Cloudera ML</Link>
    </li>
  </Fragment>
);
export const Solution = () => (
  <Fragment>
    <li>
      <Link to="/AI-Accounting-Finance">Accounting & Finance</Link>
    </li>
    <li>
     <Link to="/AI-Human-Resources">Human Resources</Link>
    </li>
    <li>
      <Link to="/AI-Operations">Operations</Link>
    </li>
    <li>
       <Link to="/AI-Audit-Compliance">Audit & Compliance</Link>
    </li>
  </Fragment>
);
export const Services = () => (
  <Fragment>
    {/* <li><Link to="/services">Services</Link></li> */}
    <li>
      <Link to="/RPA-AI">AI & RPA</Link>
    </li>
    <li>
      <Link to="/Data-Analytics">Data & Analytics</Link>
    </li>
    <li>
      <Link to="/Web-Development">Web Development</Link>
    </li>
    <li>
      <Link to="/digital-consultancy">Digital Consulting</Link>
    </li>
    <li>
      <Link to="/Whatsapp-estore">WhatsApp Services</Link>
    </li>
  </Fragment>
);
export const Projects = () => (
  <Fragment>
    <li>
      <Link to="/azure-ai-services">AI Agents</Link>
    </li>
    <li>
      <Link to="/sor">AI SOR Search</Link>
    </li>
    <li>
      <Link to="/ai-invoice">AI Invoice Data Capture</Link>
    </li>
    <li>
      <Link to="/inspection-photo">AI Inspection App</Link>
    </li>
    <li>
      <Link to="/image-extract">AI Image Data Extract</Link>
    </li>
  </Fragment>
);
export const News = () => (
  <Fragment>
    
    <li>
      <Link to="/Rpa-training">AI & RPA </Link>
    </li>
    <li>
      <Link to="/python">Python & SQL</Link>
    </li>
    <li>
      <Link to="/cloud">Data Science With Python</Link>
    </li>
    <li>
      <Link to="/Data-engineering-course">Cloudera Data Engineering</Link>
    </li>
        <li>
      <Link to="/Data-analyst">Cloudera Data  Analyst</Link>
    </li>
    <li>
      <Link to="/AI">Cloudera AI</Link>
    </li>
    <li>
      <Link to="/Machine-Learning">Cloudera ML</Link>
    </li>



    {/* <li><Link to="/blog-details">Whatsapp & openai</Link></li>
        <li><Link to="/rpa-blog">RPA</Link></li>
        <li><Link to="/react-blog">Reactjs</Link></li>
        <li><Link to="/Big-Data">Big Data</Link></li>
        <li><Link to="/Big-Data-pipeline">Big Data pipeline</Link></li> */}
  </Fragment>
);
